/**
 * Verhindert einfache html Injections
 * @param {*} htmlString
 * @returns sicherer html string
 */
 function secureHTML(htmlString) {
	if (!htmlString) {
		return '';
	}
	return htmlString.toString()
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;');
}

/**
 * Sucht ein Mitarbeiterobjekt mit der MitarbeiterID
 * @param {int} MitarbeiterID
 * @returns mitarbeiter
 */
function findeMitarbeiter(mitarbeiter, MitarbeiterID) {
	try {
		const result = mitarbeiter.find((m) => m._id === MitarbeiterID);
		if (result === undefined) {
			return {};
		}
		return result;
	} catch (error) {
		console.log(error);
		return {};
	}
}

/**
 * Sucht eine Qualifikationobjekt mit der QualifikationID
 * @param {string} QualifikationID
 * @returns qualifikation
 */
function findeQualifikation(qualifikationen, QualifikationID) {
	try {
		const result = qualifikationen.find((q) => q._id === QualifikationID);
		if (result === undefined) {
			return {};
		}
		return result;
	} catch (error) {
		console.log(error);
		return {};
	}
}

/**
 * Sucht ein Postensobjekt mit der PostenID
 * @param {string} PostenID
 * @returns posten
 */
function findePosten(postenListe, PostenID) {
	try {
		const result = postenListe.find((b) => b._id === PostenID);
		if (result === undefined) {
			return {};
		}
		return result;
	} catch (error) {
		console.log(error);
		return {};
	}
}

/**
 * Sucht ein Einsatzortobjekt mit der EinsatzortID
 * @param {string} EinsatzortID
 * @returns einsatzort
 */
function findeEinsatzort(einsatzortListe, EinsatzortID) {
	try {
		const result = einsatzortListe.find((e) => e._id === EinsatzortID);
		if (result === undefined) {
			return {};
		}
		return result;
	} catch (error) {
		console.log(error);
		return {};
	}
}

/**
 * Filtert das Schichten Array nach MitarbeiterID und gibt nur Schichten des Mitarbeiters zurück
 * @param {array<object>} schichten
 * @param {string} mitarbeiterID
 * @param {string} postenID falls leer/undefined (z.B. Mitarbeiteransicht, dedup'te Zeile ohne
 *   Posten-Bezug), werden Schichten aus allen Postens berücksichtigt statt nach genau einem gefiltert.
 * @returns sortieres alleSchichten Array
 */
function filterSchichtenMitarbeiter(schichten, mitarbeiterID, postenID) {
	try {
		const result = schichten.filter((s) => s.MitarbeiterID === mitarbeiterID && (!postenID || s.PostenID === postenID));
		if (result === undefined) {
			return {};
		}
		return result;
	} catch (error) {
		console.log(error);
		return {};
	}
}

// Intl.NumberFormat ist teuer in der Erzeugung, daher einmal anlegen und wiederverwenden.
const euroFormat = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
const euroGanzFormat = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 });
const tausendFormat = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 1 });
const zahlFormate = new Map();

// Konvertiert eine Zahl in das Euro Format.
function convertNumberToEuro(value) {
	return euroFormat.format(value);
}
// Konvertiert eine Zahl in das Euro Format.
function convertNumberDE(value, decimals = 2) {
	if (!zahlFormate.has(decimals)) {
		zahlFormate.set(decimals, new Intl.NumberFormat('de-DE', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }));
	}
	return zahlFormate.get(decimals).format(value).replace('-', '−');
}
// Ganze Euro (1.540 €), z.B. für die Kostenanzeige im Bedarfsplaner.
function convertNumberToEuroGanz(value) {
	return euroGanzFormat.format(value);
}
// Kurzform für enge Spalten: ab 1.000 € in Tausend mit einer Nachkommastelle (9,6 T€), darunter ganze Euro.
function convertNumberToEuroKurz(value) {
	if (Math.abs(value) < 1000) return convertNumberToEuroGanz(value);
	return `${tausendFormat.format(value / 1000)} T€`;
}

// Debounce, Funktionsaufruf (cb) wird erst getätigt nacht einem bestimmten delay, z.B. 1 Sekunden
function debounce(cb, delay = 1000) {
    let timeout;
    return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            cb(args);
        }, delay);
    };
}

export {
    secureHTML,
    findeMitarbeiter,
    findeQualifikation,
    findePosten,
    findeEinsatzort,
    filterSchichtenMitarbeiter,
	convertNumberToEuro,
	convertNumberToEuroGanz,
	convertNumberToEuroKurz,
	convertNumberDE,
	debounce
};
